for(let i of document.querySelectorAll('.b-portfolio-section')){
    if(i.style?.backgroundImage){
        i.classList.add('b-portfolio-section_mobile-adaptive')
    }
}